import { useState } from "react";
import { Link } from "react-router-dom";
import API from "../config/api.js";

export default function EmailCard({ email, onRemove }) {
  const [isFavorite, setIsFavorite] = useState(email.idemailfavorite !== null);
  const [isUsed, setIsUsed] = useState(email.idemailused !== null);

  const id = email.idemail;
  const categories = Array.isArray(email.categories) ? email.categories : [];

  const isNew = email.date &&
    new Date(email.date) > new Date(Date.now() - 20 * 24 * 60 * 60 * 1000);

  const handleAssistant = () => {
    window._assistant_text_add?.(email.content);
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(email.content || "");
      window._alert?.("success", "Copied to clipboard");
    } catch (_) {}
  };

  const handleUsed = async () => {
    const next = !isUsed;
    setIsUsed(next);
    try {
      const fd = new FormData();
      fd.append("idemail", id);
      const res = await fetch(`${API.emails}?used`, {
        method: "POST", credentials: "include", body: fd,
      });
      const status = await res.json();
      setIsUsed(status === true);
    } catch (_) { setIsUsed(!next); }
  };

  const handleFavorite = async () => {
    const next = !isFavorite;
    setIsFavorite(next);
    try {
      const fd = new FormData();
      fd.append("idemail", id);
      const res = await fetch(`${API.emails}?favorite`, {
        method: "POST", credentials: "include", body: fd,
      });
      const status = await res.json();
      setIsFavorite(status === true);
    } catch (_) { setIsFavorite(!next); }
  };

  const handleRemove = async () => {
    if (!window.confirm("Remove this email?")) return;
    try {
      const fd = new FormData();
      fd.append("idemail", id);
      await fetch(`${API.emails}?remove`, {
        method: "POST", credentials: "include", body: fd,
      });
      onRemove?.(id);
    } catch (_) {}
  };

  const isOwner = !!email.iduser;

  return (
    <div className={`card h-100 rounded-4 email email-${id} animate__animated animate__fadeIn animate__slow`}>
      <div className="card-header bg-white rounded-4 border-0 p-3 pb-0">
        {isNew && (
          <div className="position-absolute top-0 end-0">
            <div className="bg-secondary-light text-dark rounded shadow-sm py-2 text-center m-2 px-3 small new-tag">
              NEW
            </div>
          </div>
        )}

        <div className="mb-2 categories">
          {categories
            .filter((c) => c.type === "email")
            .map((c) => (
              <Link
                key={c.idcategory}
                className="link-primary me-2 mb-2 fw-bold"
                to={`/emails?type=${email.type}&idcategory=${c.idcategory}`}
              >
                {c.title}
              </Link>
            ))}
        </div>

        <h6 className="card-title fs-6 mb-0 email-title">{email.title}</h6>
      </div>

      <div className="card-body">
        <p
          className="card-text email-content"
          style={{ whiteSpace: "pre-line" }}
        >
          {email.content}
        </p>
      </div>

      <div className="card-footer bg-transparent p-3">
        <div className="row align-items-center">
          <div className="col-auto">
            <button
              type="button"
              className="btn btn-outline-primary btn-email-edit"
              onClick={() => window._email_edit?.(id, email.title, email.content)}
            >
              <i className="fi fi-rr-pencil" /> Edit
            </button>
          </div>

          <div className="col text-end action-buttons">
            <button
              type="button"
              className="btn btn-caption-copy"
              title="Open in Estelle"
              onClick={handleAssistant}
            >
              <i className="fi fi-rr-bulb" />
            </button>

            <button
              type="button"
              className="btn"
              title="Copy"
              onClick={handleCopy}
            >
              <i className="fi fi-rr-duplicate" />
            </button>

            <button
              type="button"
              className="btn btn-email-used"
              title="Mark as used"
              onClick={handleUsed}
            >
              <i className={isUsed ? "fi fi-rr-checkbox" : "fi fi-rr-square"} />
            </button>

            <button
              type="button"
              className="btn btn-email-favorite"
              title="Favorite"
              onClick={handleFavorite}
            >
              <i className={isFavorite ? "fi fi-sr-heart" : "fi fi-rr-heart"} />
            </button>

            {isOwner && (
              <button type="button" className="btn" onClick={handleRemove}>
                <i className="fi fi-rr-trash" />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}